export default "__VITE_ASSET__16f72bbb__"